module.exports = __webpack_public_path__ + "static/img/designGuide2.4bdbf72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide2.png
// module id = y91T
// module chunks = 2